const DESIGNER_PORTAL_URL = 'https://drafter.boxbyld.tech';


export const AUTH_URL = `${DESIGNER_PORTAL_URL}/api/auth`;
export const USER_AUTH = `${DESIGNER_PORTAL_URL}/api/user`;

export const DESIGN_REQUEST = `${DESIGNER_PORTAL_URL}/api/design-requests`;

export const STATES_API = `https://crm.boxbyld.tech/api/v1/countries/country-api/231`;
